// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import 'isomorphic-fetch';
import Vue from 'vue';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import VueI18n from 'vue-i18n';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import * as locales from '@/locales';
import errorReporter from '@/utils/error-reporter';
import pluginTelemetry from '@/utils/vue-plugin-telemetry';
import mixinLogger from '@/utils/mixin-logger';
import router from './router';
import store from './store';

import './scss/g2w.scss';

Vue.use(BootstrapVue);
Vue.use(VueRouter);

Vue.config.productionTip = false;

errorReporter.initialize(store.state.g2wEnv.current);

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: locales.findLanguage(locales.detectedLanguage),
  fallbackLocale: locales.fallbackLanguage,
  messages: locales.allLanguages
});

Vue.mixin(mixinLogger);
Vue.use(pluginTelemetry);

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  template: '<router-view></router-view>',
  router,
  store,
  i18n,
  errorCaptured: errorReporter.vueErrorCaptured
});
